import { StyledShareButtonContainer, StyledShareButtonLink } from 'components/Selfiebooth/ShareDisplay/styled'
import { FaFacebookF } from 'react-icons/fa'
import React, { useState } from 'react'
import { VISIT_URL } from 'consts'
import Spinner from 'components/Spinner'
import { addFileToFacebookShares } from 'store/actions/fileUpload'
import { SelfieBoothType, ShareFacebookSelfieBoothType } from '../../../types/selfiebooth'
import { withTranslation } from 'react-i18next'

interface FacebookProps {
	share: ShareFacebookSelfieBoothType;
	app: any;
	fileId: string;
	selfiebooth: SelfieBoothType;
	t: any
}
const Facebook = ({ app, share, fileId, selfiebooth, t }: FacebookProps) => {
	const [isLoading, setIsLoading] = useState<boolean>(false);
	const link = `https://www.facebook.com/dialog/share?app_id=2421154144601784&display=popup&hashtag=${encodeURIComponent(
		share.hashtag
	)}&href=${encodeURIComponent(`${VISIT_URL}/${app.id}/fbs/${fileId}`)}&quote=${encodeURIComponent(share.message || '')}&sdk=joey`

	const handleClick = async () => {
		setIsLoading(true)
		await addFileToFacebookShares(app.id, fileId, selfiebooth.id, selfiebooth.part.shareFacebook.cardId, true, 'share-to-facebook')
		setIsLoading(false)
	}

	return <>
		<StyledShareButtonContainer $isSpinner={false}>
			<StyledShareButtonLink href={link} target="_blank" $type="facebook" onClick={handleClick}>
				<i>{isLoading ? <Spinner isLoading={isLoading} style={{ top: '10px', left: '10px' }} /> : <FaFacebookF />}</i>
				<label>{share.label || t('photobooth.facebook')}</label>
			</StyledShareButtonLink>
		</StyledShareButtonContainer>
	</>;
}

export default withTranslation()(Facebook);